// extracted by mini-css-extract-plugin
export default {"section":"Section__section__ui6tb","head":"Section__head__HKIjl","title":"Section__title__BFRTg","extra":"Section__extra__lYjvW","body":"Section__body__DWgms"};